/**
 * Kennzeichen für einen Dispo-Eintrag einer BK: farbiger Punkt + Art
 * (Verfügbarkeit / Urlaub / Kein Kontakt) + Zeitraum.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getThemeColors } from '../../lib/theme';
import { formatDate } from '../../lib/dateFormat';
import { bkAvailabilityByGrund, type BkAvailabilityEntry } from '../../lib/bkAvailability';

/** „01.10.2026 – 20.10.2026" bzw. „ab 01.11.2026" (offenes Ende). */
export function bkAvailabilityPeriod(
  entry: Pick<BkAvailabilityEntry, 'startdatum' | 'enddatum'>,
  t: (k: string, opts?: Record<string, unknown>) => string,
): string {
  const from = formatDate(entry.startdatum);
  return entry.enddatum
    ? `${from} – ${formatDate(entry.enddatum)}`
    : t('betreuung.availability.from', { date: from });
}

export function BkAvailabilityBadge({ entry, dark, showPeriod = true }: {
  entry: Pick<BkAvailabilityEntry, 'grund' | 'startdatum' | 'enddatum' | 'is_current'>;
  dark: boolean;
  showPeriod?: boolean;
}) {
  const { t } = useTranslation();
  const tc = getThemeColors(dark);
  const def = bkAvailabilityByGrund(entry.grund);
  const color = def?.color ?? tc.muted;
  return (
    <span data-testid="bk-availability-badge" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', fontSize: 12 }}>
      <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 5, fontWeight: 700, borderRadius: 999,
        padding: '2px 9px', background: `${color}1f`, color, whiteSpace: 'nowrap',
      }}>
        <span style={{ width: 7, height: 7, borderRadius: '50%', background: color, display: 'inline-block' }} />
        {def ? t(def.labelKey) : entry.grund}
      </span>
      {showPeriod && (
        <span style={{ color: tc.muted, whiteSpace: 'nowrap' }}>
          {bkAvailabilityPeriod(entry, t)}
          {entry.is_current ? ` · ${t('betreuung.availability.current')}` : ''}
        </span>
      )}
    </span>
  );
}
